$(document).ready(function () {
  // Intercept direct navigation to /cart
  if (window.location.pathname === '/cart') {
    window.location.replace('/');
  }

  // Intercept all links to /cart and open the drawer
  $('a[href="/cart"]').click(function (event) {
    event.preventDefault();
    showCartDrawer();
  });

  // Prevent form submissions leading to /cart
  $('form[action="/cart"]').submit(function (event) {
    event.preventDefault();
    showCartDrawer();
  });

  function hideCartDrawer() {
    $('.md_cart_drawer_outer').removeClass('active');
    $('.md_cart_drawer').removeClass('active');
    $('html').removeClass('overflow_hidden');
    setTimeout(function () {
      $('.md_cart_drawer_outer').hide();
    }, 100);
  }

  function showCartDrawer() {
    $('.md_cart_drawer_outer').css('display', 'flex');
    $('html').addClass('overflow_hidden');
    setTimeout(function () {
      $('.md_cart_drawer_outer').addClass('active');
      $('.md_cart_drawer').addClass('active');
    }, 100);
  }

  $('.md_cart_close').click(hideCartDrawer);

  $('.md_cart_drawer_outer').click(function (event) {
    if (!$(event.target).closest('.md_cart_drawer').length) {
      hideCartDrawer();
    }
  });

  $('.header__icon--cart').click(function (event) {
    event.preventDefault();
    showCartDrawer();
  });

  $('#add-to-cart').click(function (event) {
    event.preventDefault();
    var form = $(this).closest('form');
    var formData = form.serialize();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function (response) {
        showCartDrawer();
        buildCart();
        updateUpsell();
      },
      error: function (xhr) {
        const response = JSON.parse(xhr.responseText);
      },
    });
  });
});

function buildCart() {
  setTimeout(function () {
    var cart_item = [];
    jQuery.getJSON('/cart.js', function (cart) {
      var compare_price_integer = 0;
      var currency = '$';
      var discounts = 0;

      for (var i = 0; i < cart.items.length; i++) {
        var quantity = cart.items[i].quantity;
        var price = (cart.items[i].price * quantity) / 100;
        var compare_price = cart.items[i].original_price / 100;

        // Price check
        $('.All_product_selector__js').each(function () {
          if ($(this).attr('data-id') == cart.items[i].id) {
            compare_price = $(this).attr('data-compare-price');
          }
        });
        compare_price = ((compare_price * quantity) / 100).toFixed(2);
        compare_price = parseFloat(compare_price);
        compare_price_integer = compare_price_integer + compare_price;

        // Corrected Discount Logic
        if (!isNaN(compare_price) && compare_price > 0) {
          if (cart.items[i].selling_plan_allocation) {
            // Subscription Discount: 40% off compare_price
            var subscriptionPrice = (compare_price * 0.6).toFixed(2); // 60% of compare_price
            var discountAmount = (compare_price * 0.4).toFixed(2); // 40% discount
            var price_line =
              currency +
              subscriptionPrice +
              ' <s>' +
              currency +
              compare_price +
              '</s>';
            var discount =
              '<p class="md_cart_item_discount">You saved 40% (' +
              currency +
              discountAmount +
              ')</p>';
            discounts += parseFloat(discountAmount); // Add subscription discount
          } else {
            // One-Time Purchase Discount
            if (compare_price > price) {
              var discount_int = (compare_price - price).toFixed(2);
              var discount_off =
                100 - ((100 * price) / compare_price).toFixed(0);
              if (discount_off > 0) {
                var discount =
                  '<p class="md_cart_item_discount">You saved ' +
                  discount_off +
                  '% (' +
                  currency +
                  discount_int +
                  ')</p>';
                discounts += parseFloat(discount_int); // Add valid discount
              }
              var price_line =
                currency +
                price.toFixed(2) +
                ' <s>' +
                currency +
                compare_price +
                '</s>';
            } else {
              var price_line = currency + price.toFixed(2);
              var discount = '';
            }
          }
        } else {
          var price_line = currency + price.toFixed(2);
          var discount = '';
        }

        // Variant Title check
        var variant_title = cart.items[i].variant_title;
        var selling_plan = cart.items[i].selling_plan_allocation;

        if (variant_title) {
        } else {
          variant_title = '';
        }

        if (
          selling_plan &&
          selling_plan.selling_plan &&
          selling_plan.selling_plan.options[i]
        ) {
          selling_plan = `Auto Renew ${selling_plan.selling_plan.options[i].value}`;
        } else {
          selling_plan = 'One-Time Purchase';
        }

        cart_item[i] = `
         <div class="md_cart_item_box">
          <div class="md_cart_item" data-id="${cart.items[i].id}">
              <span class="md_cart_remove_btn">
                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.25 2H9.5V1.5C9.5 0.672906 8.82709 0 8 0H6C5.17291 0 4.5 0.672906 4.5 1.5V2H1.75C1.06075 2 0.5 2.56075 0.5 3.25V5C0.5 5.27612 0.723875 5.5 1 5.5H1.27325L1.70522 14.5713C1.74338 15.3725 2.4015 16 3.2035 16H10.7965C11.5985 16 12.2567 15.3725 12.2948 14.5713L12.7268 5.5H13C13.2761 5.5 13.5 5.27612 13.5 5V3.25C13.5 2.56075 12.9392 2 12.25 2ZM5.5 1.5C5.5 1.22431 5.72431 1 6 1H8C8.27569 1 8.5 1.22431 8.5 1.5V2H5.5V1.5ZM1.5 3.25C1.5 3.11216 1.61216 3 1.75 3H12.25C12.3878 3 12.5 3.11216 12.5 3.25V4.5C12.3459 4.5 2.13853 4.5 1.5 4.5V3.25ZM11.2959 14.5238C11.2832 14.7908 11.0638 15 10.7965 15H3.2035C2.93616 15 2.71678 14.7908 2.70409 14.5238L2.27437 5.5H11.7256L11.2959 14.5238Z" fill="#565656"/>
                  </svg>                    
              </span>
              <div class="md_cart_item_img_quantity">
                  <div class="md_cart_item_img">
                      <p class="md_cart_item_qty_badge">${
                        cart.items[i].quantity
                      }x</p>
                      <img src="${cart.items[i].image}">
                  </div>
                  <div class="hidden">
                      <div class="md_cart_cartitem_adjust__min">
                          <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 1L1 1" stroke="#E3E3ED" stroke-width="2" stroke-linecap="round"/>
                          </svg>                                    
                      </div>
                      <div class="md_cart_cartitem_adjust__val">${
                        cart.items[i].quantity
                      } </div>
                      <div class="md_cart_cartitem_adjust__plus">
                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5 9V1M1 5H9" stroke="#1C2B54" stroke-width="1.5" stroke-linecap="round"/>
                          </svg>                                                                      
                      </div>
                  </div>
              </div>
              <div>
                  <h4 class="md_cart_item_title">${
                    cart.items[i].product_title
                  }</h4>
                  <p class="md_cart_item_variant_title">${
                    cart.items[i].variant_title || 'Default'
                  }</p>
                  <p class="md_cart_item_variant_title">
                      ${
                        cart.items[i].selling_plan_allocation
                          ? cart.items[i].selling_plan_allocation.selling_plan
                              .name
                          : 'One-Time Purchase'
                      }
                  </p>
                  ${discount}
                  <div class="md_cart_item_form">
                      <p class="md_cart_item_price"><span>${price_line}</span></p>
                  </div>
              </div>
          </div>
          ${
            !cart.items[i].selling_plan_allocation
              ? `<div class="md_cart_item_sub">
                      <button 
                          class="ero_upgr_upsell uppercase" 
                          data-variant-id="${cart.items[i].id}"
                          data-compare-price="${compare_price}"
                          data-selling-plan="689590370636">
                          Subscribe & Save 40%
                      </button>
                 </div>`
              : ''
          }
      </div>`;
      }

      $('.md_cart_items').html(cart_item);
      $('.md_cart_info_qty').html(cart.item_count);

      if (discounts > 0) {
        $('.discount_price__js').html(currency + discounts.toFixed(2));
        $('.discount_section').show();
      } else {
        $('.discount_section').hide();
      }

      if (cart.item_count == 0) {
        $('.md_cart_items_outer').hide();
        $('.md_cart_summary').hide();
        $('.md_cart_empty_out').css('display', 'flex');
        $('.cart-count-bubble').hide();
        $('.md_cart_progress_slider_in').css('width', '5%');
        var treshold = ((9900 - cart.total_price) / 100).toFixed(2);
        $('.md_cart_progress_text strong').html(currency + treshold);
      } else if (cart.item_count >= 1) {
        $('.md_cart_items_outer').show();
        $('.md_cart_summary').show();
        $('.md_cart_empty_out').hide();
        $('.cart-count-bubble').show();
        $('.cart-count-bubble').find('span').html(cart.item_count);

        var cart_total = (cart.total_price / 100).toFixed(2);
        discounts = discounts.toFixed(2);
        $('.subtotal_price__js').html(currency + cart_total);
        $('.md_cart_summary .md_checkout_btn_total').html(
          currency + cart_total,
        );
        $('.discount_price__js').html(currency + discounts);

        var progress = (cart.total_price * 100) / 12900;
        var treshold = ((9900 - cart.total_price) / 100).toFixed(2);
        var treshold2 = ((12900 - cart.total_price) / 100).toFixed(2);
        if (progress > 100) {
          progress = 100;
        }
        if (treshold > 0) {
          $('.md_cart_congrats_text').hide();
          $('.md_cart_progress_text').show();
          $('.md_cart_progress2_text').hide();
          $('.md_cart_congrats_text2').hide();

          $('.notfilled_shipping_icon').show();
          $('.filled_shipping_icon').hide();
          $('.filled_discount_icon').hide();
          $('.notfilled_discount_icon').show();
        } else {
          $('.md_cart_congrats_text').show();
          $('.md_cart_progress_text').hide();

          $('.notfilled_shipping_icon').hide();
          $('.filled_shipping_icon').show();
          if (treshold2 > 0) {
            $('.md_cart_progress2_text').show();
            $('.md_cart_progress2_text strong').html(currency + treshold2);
            $('.md_cart_congrats_text2').hide();
            $('.filled_discount_icon').hide();
            $('.notfilled_discount_icon').show();
          } else {
            $('.md_cart_progress2_text').hide();
            $('.md_cart_congrats_text').hide();
            $('.md_cart_congrats_text2').show();
            $('.filled_discount_icon').show();
            $('.notfilled_discount_icon').hide();
          }
        }
        $('.md_cart_progress_slider_in').css('width', progress + '%');
        $('.md_cart_progress_text strong').html(currency + treshold);
      }
      updateUpsell();
    });
  }, 300);
}

function fetchProductImage(handle, callback) {
  fetch(`/products/${handle}.js`)
    .then((response) => response.json())
    .then((product) => {
      // Pass the product image URL to the callback function
      if (product && product.images && product.images.length > 0) {
        callback(product.images[0]); // Use the first image
      } else {
        console.error('No images found for the product.');
      }
    })
    .catch((error) => {
      console.error('Error fetching product data:', error);
    });
}

function addToCart(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: variantId, quantity: 1 }), // Add 1 item
  })
    .then((response) => response.json())
    .then((data) => {
      // Hide the upsell section
      document.getElementById('upsell-container').innerHTML = '';

      // Refresh cart and upsell section
      buildCart();
      updateUpsell();
    })
    .catch((error) => {
      console.error('Error adding product to cart:', error);
    });
}
function attachUpsellAddToCartListeners() {
  document.querySelectorAll('.add-to-cart-btn').forEach((button) => {
    button.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id'); // Get variant ID from the button
      addToCart(variantId);
    });
  });
}

function updateUpsell() {
  const productAHandle = 'laundry-softener-eco-sheets';
  const productBHandle = 'laundry-detergent-eco-sheets';

  const productAReviews = document.querySelector(`[data-product-handle="${productAHandle}"]`)?.dataset.reviewsCount || 0;
  const productBReviews = document.querySelector(`[data-product-handle="${productBHandle}"]`)?.dataset.reviewsCount || 0;
  console.log(productAReviews,productBReviews)

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      let productAInCart = false;
      let productBInCart = false;

      cart.items.forEach((item) => {
        if (item.handle === productAHandle) {
          productAInCart = true;
        }
        if (item.handle === productBHandle) {
          productBInCart = true;
        }
      });

      let upsellHTML = '';
      if (!productAInCart && productBInCart) {
        fetchProductImage(productAHandle, (imageUrl) => {
        
          const icon_star = `<svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d="M16.0754 5.71885L11.1567 4.96639L8.95208 0.263392C8.78741 -0.0877974 8.21208 -0.0877974 8.04741 0.263392L5.84342 4.96639L0.924765 5.71885C0.520766 5.78094 0.359433 6.27301 0.642766 6.56344L4.21609 10.2316L3.37143 15.4173C3.30409 15.8292 3.74342 16.1384 4.10676 15.9361L8.50008 13.5044L12.8934 15.9367C13.2534 16.137 13.6967 15.8339 13.6287 15.418L12.7841 10.2322L16.3574 6.56411C16.6407 6.27301 16.4787 5.78094 16.0754 5.71885Z" fill="#F1BF0B"/>
                </svg>`;
          upsellHTML = `
            <span class="text-[14px] leading-[20px] font-[#000000] font-bold">WANT TO TRY ADDITIONAL PRODUCTS?</span>
          <div class="md_cart_item upsell_Card">
            <div class="md_cart_upsell_image">
              <span class="md_cart_upsell_amount_badge text-[#FFFFFF]">1x</span>
               <img class="h-[100px] w-[100px] product-image" src="${imageUrl}" alt="Laundry Softener Eco Sheets">
            </div>
            <div class="flex flex-col">
              <h4 class="md_cart_item_title">Laundry Softener Eco Sheets</h4>
              <p class="md_cart_item_variant_title">Fresh Scent / 1-Pack</p>
              <p class="product-reviews">
                <div class="md_stars_outer flex flex-row items-center text-center">
                ${icon_star} ${icon_star} ${icon_star} ${icon_star} ${icon_star}
                  <span class="ml-2">${productAReviews}</span>
                </div>
              </p>
              <div class="md_cart_item_form md_cart_upsells_btns">
                <div>
                   <button class="add-to-cart-btn md_upsell_atc_btn bg-[#5DB73A] text-[#FFFFFF] w-[228px] h-[40px]" data-variant-id="49217483047244">
                      <span class="text-[14px] leading-[24px]">ADD</span>
                      <span class="h-[24px] w-[1px]"></span>
                    <span class="md_checkout_btn_total text-[14px] leading-[24px]">$20</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          `;
          document.getElementById('upsell-container').innerHTML = upsellHTML;
          attachUpsellAddToCartListeners();

        });
      } else if (!productBInCart && productAInCart) {
        fetchProductImage(productBHandle, (imageUrl) => {
         
          const icon_star = `<svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d="M16.0754 5.71885L11.1567 4.96639L8.95208 0.263392C8.78741 -0.0877974 8.21208 -0.0877974 8.04741 0.263392L5.84342 4.96639L0.924765 5.71885C0.520766 5.78094 0.359433 6.27301 0.642766 6.56344L4.21609 10.2316L3.37143 15.4173C3.30409 15.8292 3.74342 16.1384 4.10676 15.9361L8.50008 13.5044L12.8934 15.9367C13.2534 16.137 13.6967 15.8339 13.6287 15.418L12.7841 10.2322L16.3574 6.56411C16.6407 6.27301 16.4787 5.78094 16.0754 5.71885Z" fill="#F1BF0B"/>
                </svg>`;
          upsellHTML = `
          <span class="text-[14px] leading-[20px] font-[#000000] font-bold">WANT TO TRY ADDITIONAL PRODUCTS?</span>
          <div class="md_cart_item upsell_Card">
            <div class="md_cart_upsell_image">
              <span class="md_cart_upsell_amount_badge text-[#FFFFFF]">1x</span>
               <img class="h-[100px] w-[100px] product-image" src="${imageUrl}" alt="Laundry Detergent Eco Sheets">
            </div>
            <div class="flex flex-col">
              <h4 class="md_cart_item_title">Laundry Detergent Eco Sheets</h4>
              <p class="md_cart_item_variant_title">Fragrance Free / 1-Pack</p>
              <p class="product-reviews">
                <div class="md_stars_outer flex flex-row items-center text-center">
                ${icon_star} ${icon_star} ${icon_star} ${icon_star} ${icon_star}
                  <span class="ml-2">${productBReviews}</span>
                </div>
              </p>
              <div class="md_cart_item_form md_cart_upsells_btns">
                <div>
                   <button class="add-to-cart-btn md_upsell_atc_btn bg-[#5DB73A] text-[#FFFFFF] w-[228px] h-[40px]" data-variant-id="49106748637516">
                      <span class="text-[14px] leading-[24px]">ADD</span>
                      <span class="h-[24px] w-[1px]"></span>
                    <span class="md_checkout_btn_total text-[14px] leading-[24px]">$20</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          `;
          document.getElementById('upsell-container').innerHTML = upsellHTML;
          attachUpsellAddToCartListeners();
          });
      } else {
        document.getElementById('upsell-container').innerHTML = '';
      }
    });
}

buildCart();
updateUpsell();

let isRemoving = false;

$(document).on('click', '.md_cart_remove_btn', function () {
  if (isRemoving) return; // Prevent overlapping requests
  isRemoving = true;

  const removeButton = $(this);
  removeButton.prop('disabled', true); // Disable button to prevent multiple clicks

  const currentId = $(this).closest('.md_cart_item').attr('data-id');
  const data = {
    id: currentId,
    quantity: 0,
  };

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
    success: function () {
      setTimeout(() => {
        $.getJSON('/cart.js', function (cart) {
          if (cart.item_count >= 0) {
            buildCart();
          } else {
            console.error('Cart state is inconsistent.');
          }
        });
      }, 300); // Add a small delay
    },
    error: function (xhr) {
      console.error('Error removing item:', xhr.responseText);
    },
    complete: function () {
      removeButton.prop('disabled', false); // Re-enable button
      isRemoving = false; // Allow next request
    },
  });
});

$(document).on('click', '.md_cart_cartitem_adjust__plus', function () {
  var currentId = $(this).closest('.md_cart_item').attr('data-id');

  const cartItem = $(this).closest('.md_cart_item');

  if (!currentId) {
    return;
  }

  var currentQty = parseInt(
    $(this)
      .closest('.md_cart_item')
      .find('.md_cart_cartitem_adjust__val')
      .text(),
  );
  var updatedQty = currentQty + 1;

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: currentId, quantity: updatedQty },
    dataType: 'json',
    success: function () {
      buildCart();
    },
    error: function (xhr) {
      console.error('Error updating quantity:', xhr.responseText);
    },
  });
});

$(document).on('click', '.md_cart_cartitem_adjust__min', function () {
  $(this).closest('.md_cart_item_box').addClass('changing');
  var currentId = $(this).closest('.md_cart_item').attr('data-id');
  var currentQty = parseFloat(
    $(this)
      .closest('.md_cart_item')
      .find('.md_cart_cartitem_adjust__val')
      .html(),
  );
  currentQty--;

  var data = {
    id: currentId,
    quantity: currentQty,
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
    success: function () {
      buildCart();
      setTimeout(function () {
        $('.md_cart_item_box').removeClass('changing');
      }, 1000);
    },
  });
});

$(document).on('click', '.md_cart_item_sub', function () {
  $(this).closest('.md_cart_item_box').addClass('changing');
  setTimeout(function () {
    $('.md_cart_item_box').removeClass('changing');
  }, 1000);
});

$('.md_atc_button').click(function () {
  $(this).find('.md_atc_loader').show();
  $(this).find('.md_atc_text').hide();

  var currentId = $(this).attr('data-id');
  var currentQty = 1;

  var data = {
    id: currentId,
    quantity: currentQty,
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      buildCart();
      $('.md_cart_drawer_outer').css('display', 'flex');
      $('html').addClass('overflow_hidden');
      setTimeout(function () {
        $('.md_cart_drawer_outer').addClass('active');
        $('.md_cart_drawer').addClass('active');
        $('.md_atc_loader').hide();
        $('.md_atc_text').show();
      }, 600);
    },
  });
});

$('.md_upsell_atc_btn').click(function () {
  var currentId = $(this).attr('data-id');
  var currentQty = 1;

  var data = {
    id: currentId,
    quantity: currentQty,
  };
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      buildCart();
    },
  });
});

$('.md_checkout_btn').click(function (event) {
  event.preventDefault(); // Prevent default action

  // Get the selected donation value
  const donationType = document.querySelector(
    'input[name="attributes[Donation]"]',
  ).value;

  // Send the donation attribute directly to checkout
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        Donation: donationType, // Set the donation attribute
      },
    }),
  })
    .then(() => {
      // Redirect to checkout after setting the attribute
      window.location.href = '/checkout';
    })
    .catch((error) => {
      console.error('Error sending donation to checkout:', error);
    });
});

$('.md_accordion_title').click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this)
      .closest('.md_footer_menu_cont')
      .find('.md_footer_menu_content')
      .slideUp();
  } else {
    $('.md_footer_menu_content').slideUp();
    $('.md_accordion_title').removeClass('active');
    $(this).addClass('active');
    $(this)
      .closest('.md_footer_menu_cont')
      .find('.md_footer_menu_content')
      .slideDown();
  }
});

$(document).on('click', '.ero_upgr_upsell', function () {
  var variantId = $(this).data('variant-id'); // Variant ID
  var sellingPlan = $(this).data('selling-plan'); // Selling Plan ID
  var comparePrice = parseFloat($(this).data('compare-price')); // Compare Price (original price)

  if (!variantId || !sellingPlan || !comparePrice) {
    return;
  }

  // Calculate the subscription price (40% discount on compare price)
  var subscriptionPrice = (comparePrice * 0.6).toFixed(2);

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id: variantId,
      quantity: 1,
      selling_plan: sellingPlan,
    },
    dataType: 'json',
    success: function () {
      buildCart(); // Refresh cart to reflect changes
    },
    error: function (xhr) {
      console.error('Error upgrading to subscription:', xhr.responseText);
    },
  });
});
